import CommonInterLinking from "./common-interlinking";

export default CommonInterLinking;
